<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 210px">
        <p>批次号：</p>
        <el-input v-model="batchIpt" size="mini" style="width:150px" placeholder="请输入批次号"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>运单编号：</p>
        <el-input v-model="waybillIpt" size="mini" style="width:150px" placeholder="请输入运单编号"/>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>底盘号：</p>
        <el-input v-model="chassisIpt" size="mini" style="width:150px" placeholder="请输入底盘号"/>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>委托商：</p>
        <el-input v-model="entrustIpt" size="mini" style="width:150px" placeholder="请输入委托商"/>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>经销商：</p>
        <el-input v-model="dealersIpt" size="mini" style="width:150px" placeholder="请输入经销商"/>
      </div>
      <div class="navContainer" style="width: 450px">
        <p>计划日期：</p>
        <el-date-picker
          v-model="timeIpt"
          type="daterange"
          size="mini"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始计划日期"
          end-placeholder="结束计划日期"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>运输条款：</p>
        <el-select v-model="termsIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in termsOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 270px">
        <p>是否生成对账单：</p>
        <el-select v-model="stateIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">生成对账单</el-button>
      </div>
    </div>
    <div class="content">
      <div class="contentNav">
        <div class="contentNavLeft">
          <el-checkbox-group v-model="checkList" @change="checkListChange">
            <el-checkbox v-for="item in checkListArr" :label="item.label" :indeterminate="item.state" v-model="item.state2">{{item.text}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="contentNavRight">
          <span>导入生成对账单</span>
          <span>导出数据</span>
        </div>
      </div>
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          ref="multipleTable"
          :data="TableDatas"
          style="width: 100%"
          border
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          @select="handleSelectionChange"
          @select-all="selectAll"
          :row-key="bindRowKeys"
        >
          <el-table-column
            type="selection"
            width="50"
            :selectable="selectable"
            :reserve-selection="true"
          />
          <el-table-column prop="batch" label="批次号" align="center"/>
          <el-table-column prop="waybill" label="运单编号" align="center"/>
          <el-table-column prop="chassis" label="底盘号" align="center"/>
          <el-table-column prop="brand" label="品牌" align="center"/>
          <el-table-column prop="model" label="型号" align="center"/>
          <el-table-column prop="entrust" label="委托商" align="center"/>
          <el-table-column prop="dealers" label="经销商" align="center"/>
          <el-table-column prop="planDate" label="计划日期" align="center"/>
          <el-table-column prop="shipDate" label="发运日期" align="center"/>
          <el-table-column prop="carDate" label="交车日期" align="center"/>
          <el-table-column label="运输条款" align="center">
            <div slot-scope="scope">{{getTerms(scope.row.terms)}}</div>
          </el-table-column>
          <el-table-column prop="rate" label="税率%" align="center"/>
          <el-table-column prop="noTax" label="含税价" align="center"/>
          <el-table-column prop="tax" label="不含税价" align="center"/>
          <el-table-column prop="type" label="预结算方式" align="center"/>
          <el-table-column prop="includTax" label="预结算含税价" align="center"/>
          <el-table-column prop="includNoTax" label="预结算不含税价" align="center"/>
          <el-table-column label="是否生成对账单" align="center">
            <div slot-scope="scope">{{getState(scope.row.state)}}</div>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='1000px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="depart">
        <div class="departBasic">
          <div class="departBasicTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
  },

  data() {
    return {
      batchIpt:'',
      waybillIpt:'',
      chassisIpt:'',
      entrustIpt:'',
      dealersIpt:'',
      timeIpt:'',
      stateIpt:'',
      termsIpt:'',
      stateOption:[
        {value:'',label:'全部',},
        {value:1,label:'是',},
        {value:0,label:'否',},
      ],
      termsOption:[
        {value:'',label:'全部',},
        {value:1,label:'公路',},
        {value:2,label:'水路',},
        {value:3,label:'水陆联运',},
      ],
      checkList:[],
      multipleSelection:[],
      maxSelection:[],
      checkListArr:[
        {text:'公路',label:1,state:false,state2:false},
        {text:'水路',label:2,state:false,state2:false},
        {text:'水陆联运',label:3,state:false,state2:false},
      ],
      tableLoad:false,
      TableDatas:[
        {id:1111,batch:'PC201210112',waybill:'BH2012151',chassis:'DP215451',brand:'品牌1',model:'型号2',entrust:'委托商1',dealers:'经销商1',planDate:'2021-9-28',shipDate:'2021-9-28',carDate:'2021-9-28',terms:1,rate:'6',noTax:'120',tax:'120',type:'固定(120)',includTax:'60',includNoTax:'58',state:0},
        {id:2222,batch:'PC201210112',waybill:'BH2012151',chassis:'DP215451',brand:'品牌1',model:'型号2',entrust:'委托商1',dealers:'经销商1',planDate:'2021-9-28',shipDate:'2021-9-28',carDate:'2021-9-28',terms:2,rate:'6',noTax:'120',tax:'120',type:'固定(120)',includTax:'60',includNoTax:'58',state:0},
        {id:9999,batch:'PC201210112',waybill:'BH2012151',chassis:'DP215451',brand:'品牌1',model:'型号2',entrust:'委托商1',dealers:'经销商1',planDate:'2021-9-28',shipDate:'2021-9-28',carDate:'2021-9-28',terms:2,rate:'6',noTax:'120',tax:'120',type:'固定(120)',includTax:'60',includNoTax:'58',state:0},
        {id:6666,batch:'PC201210112',waybill:'BH2012151',chassis:'DP215451',brand:'品牌1',model:'型号2',entrust:'委托商1',dealers:'经销商1',planDate:'2021-9-28',shipDate:'2021-9-28',carDate:'2021-9-28',terms:3,rate:'6',noTax:'120',tax:'120',type:'固定(120)',includTax:'60',includNoTax:'58',state:0},
        {id:3333,batch:'PC201210112',waybill:'BH2012151',chassis:'DP215451',brand:'品牌1',model:'型号2',entrust:'委托商2',dealers:'经销商1',planDate:'2021-9-28',shipDate:'2021-9-28',carDate:'2021-9-28',terms:3,rate:'6',noTax:'120',tax:'120',type:'固定(120)',includTax:'60',includNoTax:'58',state:0},
        {id:7777,batch:'PC201210112',waybill:'BH2012151',chassis:'DP215451',brand:'品牌1',model:'型号2',entrust:'委托商2',dealers:'经销商1',planDate:'2021-9-28',shipDate:'2021-9-28',carDate:'2021-9-28',terms:3,rate:'6',noTax:'120',tax:'120',type:'固定(120)',includTax:'60',includNoTax:'58',state:0},
        {id:4444,batch:'PC201210112',waybill:'BH2012151',chassis:'DP215451',brand:'品牌1',model:'型号2',entrust:'委托商1',dealers:'经销商1',planDate:'2021-9-28',shipDate:'2021-9-28',carDate:'2021-9-28',terms:1,rate:'6',noTax:'120',tax:'120',type:'固定(120)',includTax:'60',includNoTax:'58',state:0},
        {id:5555,batch:'PC201210112',waybill:'BH2012151',chassis:'DP215451',brand:'品牌1',model:'型号2',entrust:'委托商3',dealers:'经销商1',planDate:'2021-9-28',shipDate:'2021-9-28',carDate:'2021-9-28',terms:1,rate:'6',noTax:'120',tax:'120',type:'固定(120)',includTax:'60',includNoTax:'58',state:0},
        {id:8888,batch:'PC201210112',waybill:'BH2012151',chassis:'DP215451',brand:'品牌1',model:'型号2',entrust:'委托商1',dealers:'经销商1',planDate:'2021-9-28',shipDate:'2021-9-28',carDate:'2021-9-28',terms:1,rate:'6',noTax:'120',tax:'120',type:'固定(120)',includTax:'60',includNoTax:'58',state:1},
      ],
      page:1,
      size:10,
      total:0,
      dialogTitle:'',
      dialogVisible:false,
      billData:{
        entrust:'',
        tax:'',
        noTax:'',
        includTax:'',
        includNoTax:'',
        title:'',
        type:'',
        price:'',
        remark:'',
      },
      rules:{
        type:[
          { required: true, message: '请选择地址类型', trigger: 'change' },
        ],
        name:[
          { required: true, message: '请输入地址名称', trigger: 'blur' },
        ],
        address:[
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        area:[
          { required: true, message: '请现在所在区域', trigger: 'change' },
        ],
      },
      oldList:{},
    };
  },
  computed:{
    getTerms(){
      return function(terms){
        switch(terms) {
          case 1:
            return '公路'
          case 2:
            return '水路'
          case 3:
            return '水陆联运'
        }
      };
    },
    getState(){
      return function(state){
        switch(state) {
          case 0:
            return '否'
          case 1:
            return '是'
        }
      };
    },
  },
  watch:{
    TableDatas(val){
      val.forEach(item=>{
        this.maxSelection.forEach(self=>{
          if(self.id === item.id){
            this.$refs.multipleTable.toggleRowSelection(item,true)
          }
        })
      })
    },
    multipleSelection(val){
      if(val.length ===0){
        this.checkList=[];
        this.checkListArr.forEach(item=> {
          item.state2 = false
          item.state=false
        })
      }
    },
    checkList(val,oldVal){
      if(oldVal.length===0) return this.oldList= {val:val[0],operation:'add'};
      if(val.length>oldVal.length){
        val.forEach(item=>{
          if(oldVal.indexOf(item) === -1) return this.oldList= {val:item,operation:'add'};
        })
      }else{
        oldVal.forEach(item=>{
          if(val.indexOf(item) === -1) return this.oldList= {val:item,operation:'reduce'};
        })
      }
    },
  },
  methods: {
    checkListChange(){
      const newTableDatas=[];
      this.TableDatas.forEach(row=>{if(!row.state) newTableDatas.push(row)});
      let entrustId='';
      this.multipleSelection.forEach(item=>{
        if(this.maxSelection.indexOf(item) !== -1){
          this.maxSelection.splice(this.maxSelection.indexOf(item),1);
        }
      })
      if(this.checkList.length===0) {
        this.$refs.multipleTable.clearSelection();
        this.multipleSelection = [];
      } else {
        if(this.multipleSelection.length===0) {
          entrustId = newTableDatas[0].entrust;
          for(let i=0;i<newTableDatas.length;i++){
            if(newTableDatas[i].entrust === entrustId && this.oldList.val===newTableDatas[i].terms){
              this.multipleSelection.push(newTableDatas[i])
            }
          }
        } else {
          entrustId = this.multipleSelection[0].entrust;
          if(this.oldList.operation==='add'){
            for(let i=0;i<newTableDatas.length;i++){
              if(newTableDatas[i].entrust === entrustId && this.oldList.val===newTableDatas[i].terms){
                if(this.multipleSelection.indexOf(newTableDatas[i])===-1) this.multipleSelection.push(newTableDatas[i])
              }
            }
          }else{
            this.$refs.multipleTable.clearSelection();
            for(let i=0;i<this.multipleSelection.length;i++){
              if(this.oldList.val===this.multipleSelection[i].terms){
                this.multipleSelection.splice(i,1);
                i--;
              }
            }
          }
        }
      }
      for(let i=0;i<this.multipleSelection.length;i++){
        for(let j=0;j<newTableDatas.length;j++){
          if(newTableDatas[j].id === this.multipleSelection[i].id){
            this.$refs.multipleTable.toggleRowSelection(newTableDatas[j],true);
          }
        }
      }
      this.checkMethod(1,0,entrustId);
      this.checkMethod(2,1,entrustId);
      this.checkMethod(3,2,entrustId);
    },
    resetBtn(){
      this.stateIpt='';
      this.batchIpt='';
      this.waybillIpt='';
      this.chassisIpt='';
      this.entrustIpt='';
      this.dealersIpt='';
      this.timeIpt='';
      this.termsIpt='';
      this.contractSizeChange();
    },
    selectable(row){
      return !row.state;
    },
    selectAll(){
      const newTableDatas=[];
      this.TableDatas.forEach(row=>{if(!row.state) newTableDatas.push(row)});
      const len = this.multipleSelection.length;
      this.$refs.multipleTable.clearSelection();
      let entrustId='';
      if(this.multipleSelection.length === 0) entrustId=newTableDatas[0].entrust;
      else entrustId=this.multipleSelection[0].entrust;
      for(let i=0;i<newTableDatas.length;i++) {
        if(newTableDatas[i].entrust === entrustId){
          if(this.multipleSelection.indexOf(newTableDatas[i].id) === -1){
            this.multipleSelection.push(newTableDatas[i]);
          }
        }
      }
      this.multipleSelection=this.unique(this.multipleSelection,'id');
      if(len === this.multipleSelection.length){
        this.multipleSelection=[];
        this.checkList=[];
        this.checkListArr.forEach(item=>item.state2=false)
        return this.$refs.multipleTable.clearSelection();
      }
      this.checkList=[1,2,3];
      this.checkListArr.forEach(item=>item.state2=true)
      for(let i=0;i<this.multipleSelection.length;i++){
        for(let j=0;j<newTableDatas.length;j++){
          if(newTableDatas[j].id === this.multipleSelection[i].id){
            this.$refs.multipleTable.toggleRowSelection(newTableDatas[j],true);
          }
        }
      }
      this.checkMethod(1,0,entrustId);
      this.checkMethod(2,1,entrustId);
      this.checkMethod(3,2,entrustId);
    },
    unique(arr,attr) {
      const res = new Map();
      return arr.filter(item=>{
        let attrItem = item[attr];
        return !res.has(attrItem) && res.set(attrItem,1)
      })
    },
    handleSelectionChange(selection,row){
      if(this.maxSelection.indexOf(row)===-1) this.maxSelection.push(row);
      else this.maxSelection.splice(this.maxSelection.indexOf(row),1);
      if(this.multipleSelection.length===0) {
        this.multipleSelection = selection;
        this.checkList.push(row.terms);
      } else {
        if(row.entrust === this.multipleSelection[0].entrust) {
          const len = this.multipleSelection.length;
          this.multipleSelection = selection;
          if(len<this.multipleSelection.length){
            for(let i=0;i<this.multipleSelection.length;i++) {
              if(this.checkList.indexOf(this.multipleSelection[i].terms) === -1){
                this.checkList.push(this.multipleSelection[i].terms)
              }
            }
          }else{
            const arr=[];
            for(let i=0;i<this.multipleSelection.length;i++){
              if(arr.indexOf(this.multipleSelection[i].terms)===-1){
                arr.push(this.multipleSelection[i].terms)
              }
            }
            this.checkList=arr;
          }
        }
        else {
          this.maxSelection.splice(this.maxSelection.indexOf(row),1);
          this.$refs.multipleTable.toggleRowSelection(row,false);
          this.$message.warning('勾选的委托商必须一致！');
        }
      }
      this.checkMethod(1,0,row.entrust);
      this.checkMethod(2,1,row.entrust);
      this.checkMethod(3,2,row.entrust);
    },
    checkMethod(val,index,id){
      const newTableDatas=[];
      this.TableDatas.forEach(row=>{if(!row.state) newTableDatas.push(row)});
      if(this.checkList.length===0) return this.checkList.forEach(item=>item.state=false);
      let len11=0;
      let len12=0;
      newTableDatas.forEach(item=>{
        if(item.terms===val && item.entrust ===id) len11++;
      })
      this.multipleSelection.forEach(item=>{
        if(item.terms===val) len12++;
      })
      this.checkListArr[index].state = len11 !== len12;
      if(len12===0) {
        this.checkListArr[index].state = false;
        this.checkListArr[index].state2 = false;
      }
    },
    bindRowKeys(row){
      return row.id
    },
    searchBtn(){
      this.page = 1
    },
    addBtn(){
      this.dialogVisible=true;
      this.dialogTitle='生成对账单';
      this.multipleSelection.forEach(item=> {
        if(this.maxSelection.indexOf(item)===-1) this.maxSelection.push(item)
      });
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this.multipleSelection.forEach(item=> {
        if(this.maxSelection.indexOf(item)===-1) this.maxSelection.push(item)
      });
    },
    contractCurrentChange(page){
      this.page=page;
      this.multipleSelection.forEach(item=> {
        if(this.maxSelection.indexOf(item)===-1) this.maxSelection.push(item)
      });
    },
    dialogClose(){
      this.dialogVisible=false;
      this.billData={
        entrust:'',
        tax:'',
        noTax:'',
        includTax:'',
        includNoTax:'',
      };
      this.$refs.ruleForm.resetFields();
    },
    addClick(){
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.billData={
            entrust:'',
            tax:'',
            noTax:'',
            includTax:'',
            includNoTax:'',
          };
          this.dialogVisible=false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    &Nav{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &Left{
        ::v-deep{
          .el-checkbox__label{
            color:#727070;
            font-size:12px;
          }
        }
      }
      &Right{
        span{
          font-size:14px;
          color: rgba(51, 136, 255, 1);
          text-decoration: underline;
          margin-right: 10px;
          &:hover{
            cursor: pointer;
          }
        }
      }
    }
    .tableContainer{
      margin-top: 10px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-checkbox{
          margin-left: 16px;
        }
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
        .el-table th>.cell{
          font-weight: 700!important;
        }
        .el-table__header .el-table-column--selection .cell .el-checkbox:after{
          color: rgb(127, 127, 127);
          content: "全选";
          font-size:12px;
          font-weight: 700;
          //margin-left: 2px;
        }
        .el-table__header .el-table-column--selection .cell .el-checkbox{
          margin-left: 8px;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .depart{
    width:100%;
    padding: 20px 10px;
    &Basic{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  .permissions{
    width:100%;
    padding: 20px 10px 20px 50px;
    .name{
      display:flex;
      align-items:center;
      margin-bottom: 20px;
      span{
        color: #2F1010;
      }
    }
    .content1{
      p{
        color: #2F1010;
      }
    }
    .tree{
      border:1px solid #D2D2D2;
      width: 400px;
      height: 280px;
      margin-left: 60px;
      border-radius: 5px;
      padding:5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }
    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }
    .el-dialog__headerbtn{
      top:9px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
